import logo from './logo.svg';
import '@milestone-sys/web-design-system/main.css';
import './app-bar.scss';
import Button from 'components/Button/Button';

function AppBar(props: AppBarProps) {
    const { isAuthenticated, onLoginButtonClicked } = props;

    return (
        <div className="container-fluid app-bar p-4">
            <div className="row">
                <div className="col-12 d-flex justify-content-between align-items-center">
                    <img className="app-bar__logo" src={logo} alt="logo"></img>
                    <div className="app-bar__header msds-text-header-2 msds-text-clear-blue">
                        MIP License Management
                    </div>
                    <Button color="tertiary" onClick={onLoginButtonClicked} className="app-bar__sign-in">
                        {isAuthenticated ? 'Sign out' : 'Sign in'}
                    </Button>    
                </div>
            </div>            
        </div>
    );
}

export default AppBar;

type AppBarProps = {
    isAuthenticated: boolean;
    onLoginButtonClicked?: () => void;
};
